import { useCallback } from "react";

import { useLocale } from "../../../shared/i18n";
import {
  adminAccessMessages,
  type AdminAccessMessageKey,
} from "../../../shared/i18n/adminAccessMessages";
import { useShellT, type ShellKey } from "../useShellT";

export type AccessKey = ShellKey | AdminAccessMessageKey;
export type AccessTranslate = (key: AccessKey) => string;

export function isAccessKey(key: string): key is AdminAccessMessageKey {
  return key in adminAccessMessages;
}

/** Looks in adminAccessMessages first, then the shell and shared catalogs. */
export function useAccessT(): AccessTranslate {
  const { locale } = useLocale();
  const shellT = useShellT();
  return useCallback(
    (key: AccessKey) =>
      isAccessKey(key) ? adminAccessMessages[key][locale] : shellT(key),
    [locale, shellT],
  );
}

/** Replaces {name} placeholders in a message. */
export function fill(text: string, values: Record<string, string>): string {
  return Object.entries(values).reduce(
    (result, [name, value]) => result.replaceAll(`{${name}}`, value),
    text,
  );
}
